import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useLazyGetGameBoardQuery } from '@/api/queries/game';
import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import { calcSecondsToDate } from '@/common/lib/time';
import { milisecondsToTime } from '@/common/lib/timer';
import { H3, StringXSmall } from '@/components/Typography/Typography';
import { useAppSelector } from '@/redux/store';

import css from './styles.module.scss';

const TimeToEndPhase: FC = () => {
  const { t } = useTranslation();
  const nextEventStartsAt = useAppSelector(
    (state) => state.diceGame.nextEventStartsAt,
  );
  const [getGameBoard] = useLazyGetGameBoardQuery();
  const requestGameBoardAfterTimerEnd = (seconds: number): void => {
    if (seconds === 0 && !!nextEventStartsAt) {
      getGameBoard();
    }
  };
  const secondsToNextEvent = useCountDownTimer(
    calcSecondsToDate(nextEventStartsAt),
    requestGameBoardAfterTimerEnd,
  );

  const timeData = milisecondsToTime(secondsToNextEvent * 1000);

  const timeUnitsData: Array<{
    timeUnit: 'days' | 'hours' | 'minutes' | 'seconds';
    isLast?: boolean;
  }> = [
    {
      timeUnit: 'days',
    },
    {
      timeUnit: 'hours',
    },
    {
      timeUnit: 'minutes',
    },
    {
      timeUnit: 'seconds',
      isLast: true,
    },
  ];

  return (
    <div className="flex h-[3.125rem] gap-1 w-[17.625rem] py-2 px-6 rounded-[80px] bg-white/10 backdrop-blur-[32px] mt-6 mb-10">
      {timeUnitsData.map((data) => (
        <>
          <div className="flex flex-col items-center justify-between h-full w-12">
            <H3 weight="bold" className={cn('!text-gold', css.textShadow)}>
              {t(timeData[data.timeUnit])}
            </H3>
            <StringXSmall className="!text-white/60 !text-[12px]">
              {data.timeUnit}
            </StringXSmall>
          </div>
          {!data?.isLast && (
            <H3 weight="bold" className={css.boxShadow}>
              :
            </H3>
          )}
        </>
      ))}
    </div>
  );
};

export { TimeToEndPhase };
